module.exports = {
          srcSet: "/_next/static/images/img-sports@2x-200-eb066bda8cf330c920ca0cfe4f69e8ef.jpg"+" 200w",
          images:[ {path: "/_next/static/images/img-sports@2x-200-eb066bda8cf330c920ca0cfe4f69e8ef.jpg",width: 200,height: 171}],
          src: "/_next/static/images/img-sports@2x-200-eb066bda8cf330c920ca0cfe4f69e8ef.jpg",
          toString:function(){return "/_next/static/images/img-sports@2x-200-eb066bda8cf330c920ca0cfe4f69e8ef.jpg"},
          placeholder: undefined,
          width: 200,
          height: 171
      }